import { BuiltInAttribute } from "@orsane/schema/tasks";
import { memo } from "react";
import { UserAvatar } from "@/components/UserAvatar";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import type { ColumnDef } from "../ColumnModel";
import type { Row } from "../RowModel";

// Memoized cell component
const CreatedByCell = memo(function CreatedByCell({ row }: { row: Row }) {
    return (
        <div className="flex items-center justify-start h-full pl-3">
            <Tooltip>
                <TooltipTrigger>
                    <UserAvatar user={row.data.createdBy} size="xs" />
                </TooltipTrigger>
                <TooltipContent side="bottom" align="center">
                    {row.data.createdBy.name}
                </TooltipContent>
            </Tooltip>
        </div>
    );
});

export function buildCreatedByColumn(isVisible: boolean): ColumnDef {
    return {
        id: BuiltInAttribute.createdBy,
        header: "Created by",
        isVisible: isVisible,
        cssColDef: "100px",
        isRight: false,
        isReadOnly: true,
        getSortValue: ({ row }: { row: Row }) => {
            return row.data.createdBy.name ?? "None";
        },
        getGroupHeader: ({ row }: { row: Row }) => {
            return row.data.createdBy.name ?? "None";
        },
        cell: ({ row }: { row: Row }) => {
            return <CreatedByCell row={row} />;
        },
    };
}
